import { render } from "./ledgers.vue?vue&type=template&id=7e44ecde&scoped=true"
import script from "./ledgers.vue?vue&type=script&lang=js"
export * from "./ledgers.vue?vue&type=script&lang=js"

import "./ledgers.vue?vue&type=style&index=0&id=7e44ecde&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e44ecde"]])

export default __exports__